<template>
    <div class="fabric-js-container-main">
        <div id="fabric-js-container" ref="fabricJSContainer">
            <canvas id="fabric-js-canvas" class="workspace-module-container" ref="fabricJS"></canvas>
        </div>
<!--        <vue-custom-scrollbar class="design-photos-carousel-container">-->
<!--            <img v-for="(img, idPhoto) in projectPhotos" class="design-photos-carousel-img"-->
<!--                 v-bind:class="{'design-photos-carousel-img-selected': currentPhoto === idPhoto}"-->
<!--                 :src="urlForPhoto(img.src)"-->
<!--                 v-on:click="selectPhoto(idPhoto)"/>-->
<!--        </vue-custom-scrollbar>-->
    </div>
</template>

<script>
import {urlForFileStorage, urlForStaticVue} from "../../common";
import {fabricEditor} from "../../../fabric/fabricMain";
import {bus} from "../../../vue_bus";
import {threeMain} from "../../../threeJS/threeMain";
import vueCustomScrollbar from 'vue-custom-scrollbar'
import {getScale, getNormalizeScale} from "../../../fabric/libs/common";

export default {
    name: "LiteWorkspaceFabricVisualize",
    components: {
        vueCustomScrollbar
    },
    mixins: [urlForFileStorage, urlForStaticVue],
    computed: {
        activePhotoID() {
            return this.$route.params.photoID;
        },
        activePhotoAbsoluteURL() {
            const photo = this.$store.getters[`active/GET_ACTIVE_PHOTO`];
            return this.urlForFileStorage(photo.src);
        },
        activeDesignID() {
            return this.$route.params.designID;
        },
        projectPhotos() {
            return this.$store.getters['active/GET_ALL_PHOTO']
        },
        currentPage() {
            return this.$store.state.route.name
        },
        currentPhoto() {
            return this.$store.state.route.params.photoID
        }
    },
    watch: {
        activeDesignID() {
            this.editor.destroy();
            this.initFabric();
        },
        activePhotoID() {
            this.editor.destroy();
            this.initFabric();
        },
    },
    methods: {
        selectPhoto(idPhoto) {
            this.$router.push({name: this.currentPage, params: {photoID: idPhoto}}).catch(() => {
            })
        },
        urlForPhoto(url) {
            return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
        },
        initFabric: async function () {
            let renderPromise = new Promise(async (resolve, reject)=>{
                this.editor = new fabricEditor(
                    this.$refs["fabricJS"],
                    {
                        dragging: false,
                        zoom: false
                    });
                this.editor.updateCanvaSize({
                        width: this.$refs["fabricJSContainer"].offsetWidth,
                        height: this.$refs["fabricJSContainer"].offsetHeight
                    }
                );
                let size = await this.$store.dispatch("active/GET_ACTIVE_IMG_SIZE");
                this.scale = getNormalizeScale(size, this.editor.fabricJS);
                const sourceImg = await this.editor.addSourceImage(this.activePhotoAbsoluteURL, this.scale);
                this.editor.showPlanes({withTexture: true, scale: this.scale}).then(
                    ()=>{
                        // this.editor.setViewport(sourceImg, this.scale)
                        resolve(true);
                    }
                ).catch((err) => {
                    reject(err)
                });
                this.editor.setViewport(sourceImg, this.scale);
            })
          this.editor.setQuality("high");
          await this.$store.dispatch("IN_PROGRESS", renderPromise);
          // this.$store.commit("IN_PROGRESS", renderPromise);
          // await renderPromise
          // this.$store.commit("IN_PROGRESS", null);

        }
    },
    mounted() {
        this.initFabric();
        bus.$on("selectedPlaneFromPlaneVisualisator", (planeID) => {
            if (planeID === this.$route.params.planeID)
                return;

            const plane = this.$store.getters["active/PLANE_BY_ID"](planeID);

            if (!plane || !plane.idDesignGroup || !plane.type)
                return;

            this.$router.push({
                name: "lightDesignMaterialsSelected",
                params: {groupID: plane.idDesignGroup, facadeElement: plane.type}
            }).catch(() => {
            });
        });
        bus.$on("unSelectedPlaneFromPlaneVisualisator", () => {
            this.$router.push({
                name: "liteDesignListSelected",
            }).catch(() => {
            });
        });
    },
    destroyed() {
        bus.$off("selectedPlaneFromPlaneVisualisator");
        this.editor.destroy();
    },
}
</script>

<style scoped>
.fabric-js-container-main {
    width: 100%;
    height: 100%;
}

#fabric-js-container {
    width: 100%;
    height: 100%;
    /*height: calc(100% - 200px);*/
}

.design-photos-carousel-container {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: safe center;
    align-items: center;
    overflow-x: auto;
    user-select: none;
}

.design-photos-carousel-img {
    /*display: block;*/
    height: 100px;
    width: 150px;
    object-fit: cover;
    border: 2px solid #f2f2f2;
    border-radius: 4px;
    margin: 0 5px;
}

.design-photos-carousel-img:hover {
    border: 2px solid #bdbdbd;
}

.design-photos-carousel-img:active {
    border: 2px solid #d83336;
}

.design-photos-carousel-img-selected {
    border: 2px solid #d83336 !important;
}

/*.design-photos-carousel {*/
/*  display: flex;*/
/*  justify-content: safe center;*/
/*  align-items: center;*/
/*  */
/*}*/
</style>
